import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationIT from "./assets/content/translations/it/translation.json";
import translationEN from "./assets/content/translations/en/translation.json";

const resources = {
    it: { translation: translationIT },
    en: { translation: translationEN }
};

i18n
    .use(LanguageDetector) // rileva lingua browser o cookie
    .use(initReactI18next) // integra con React
    .init({
        resources,
        fallbackLng: "it", // lingua di default
        interpolation: {
            escapeValue: false // MUI gestisce già la sicurezza XSS
        }
    });

export default i18n;